<template>
  <div v-if="users.length">
    <div class="text-xl font-bold text-text leading-tight mb-4">{{ $t('collaborators') }}</div>
    <div class="members-grid members-grid--header">
      <div>{{ $t('emailLabel') }}</div>
      <div>{{ $t('roleLabel') }}</div>
      <div></div>
    </div>
    <div class="divide-y divide-border">
      <AccessUserListItem v-for="(user,i) in users" :key="i" :user="user"/>
    </div>
  </div>
</template>

<script>
import AccessUserListItem from "@/components/cabinet/SpaceSettings/AccessSettings/AccessUsersList/AccessUserListItem";

export default {
  name: "AccessUsersList",
  components: {AccessUserListItem},
  props: {
    users: {
      type: Array,
      default: () => []
    }
  },
  i18n: {
    messages: {
      en: {
        collaborators: 'Collaborators',
        emailLabel: 'Email / login',
        roleLabel: 'Role'
      },
      ru: {
        collaborators: 'Участники',
        emailLabel: 'Почта / логин',
        roleLabel: 'Роль'
      }
    }
  }
}
</script>

<style lang="scss">
.members-grid {
  @apply grid col-gap-8 py-4 items-center
  text-sm text-text-secondary font-medium;
  grid-template-columns: 40% 1fr auto;
  //49.2%

  &--header {
    @apply text-sm text-text-ternary;
  }
}
</style>